/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ICONS from "../../../assets/Icons/index.js";
import {
  bankLookUp,
  getAllCategories,
  panLookUp,
} from "../../../redux/features/sharedResources/sharedResources";
import {
  getOutsideBankingHoursLabel,
  isOutsideBankingHours,
} from "../../../utils/bankingHours.js";
import {
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../utils/configurationProvider";
import CommonAlertCard from "../../_utils/CommonAlertCard/index.jsx";
import CommonLayout from "../../_utils/CommonLayout";
import SmallPopupWithBulletPoints from "../../_utils/CommonSmallPopupWithBulletPoint/index.jsx";
import SourceDestinationAccountDetail from "../../_utils/TransactionCommonComponents/SourceDestinationAccountDetail";
import DestinationReimbursement from "../DestinationReimbursement";

const SelectAccount = ({
  txnPayLoad,
  setTxnPayLoad,
  categories,
  setCategory,
  setIsModalOpen,
  setLabelsAcc,
  setSelectedCategory,
  setCatShow,
  setCatSelect,
  mapingData,
  type,
  setAmountInWords,
  setAccountSelect,
  currentAccountDetails,
  accountSelect,
  openOwner,
  setOpenOwner,
  TypeRTGS,
  isModalOpen,
  setCategoryIds,
}) => {
  const MIN_ASSOCIATES = GlobalConfiguration.lengthCheckOne;
  const dispatch = useDispatch();
  const [havePANAssociate, setHavePANAssociate] = useState(0);
  const [haveBankAssociate, setHaveBankAssociate] = useState(0);
  const [accountNumber, setAccountNumber] = useState(
    txnPayLoad?.bankAccountNo ? txnPayLoad?.bankAccountNo : "",
  );
  const [, setBeneAccountId] = useState(
    txnPayLoad?.beneAccountId ? txnPayLoad?.beneAccountId : null,
  );
  const [IFSC, setIFSC] = useState(
    txnPayLoad?.bankAccountIFSC ? txnPayLoad?.bankAccountIFSC : "",
  );
  const [showBanner, setShowBanner] = useState(false);
  const [isOutsideBankingHoursActive, setIsOutsideBankingHoursActive] =
    useState(isOutsideBankingHours());

  const { beneSuccessData } = useSelector(
    (state) => state?.beneCreateAccountSlice,
  );

  const beneLookData = useSelector(
    (state) => state.sharedResources.panLookupData,
  );
  const bankData = useSelector((state) => state.sharedResources.bankLookupData);

  const shouldShowAssociatedAccounts =
    (haveBankAssociate > MIN_ASSOCIATES || havePANAssociate > MIN_ASSOCIATES) &&
    accountNumber &&
    IFSC;

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    setHaveBankAssociate(bankData?.total_count || 0);
    setHavePANAssociate(beneLookData?.total_count || 0);
  }, [beneLookData, bankData, dispatch]);

  const handleOwnerSelection = (name, acc, ifsc, logo, ownerId) => {
    setTxnPayLoad((prev) => ({
      ...prev,
      ownerId,
      ownerAccountName: name,
      ownerBankAccountNo: acc,
      ownerBankIFSC: ifsc,
      ownerBankLogo: logo,
    }));
  };

  const handleAccountSelection = (
    accountName,
    accountNumber,
    ifsc,
    bankLogo,
    category,
    categoryIds,
    panNo,
    beneAccountId,
    labels,
  ) => {
    const categoriesArray = category?.split(",");
    setCategory(categoriesArray);
    setCategoryIds(categoryIds);
    setAccountNumber(accountNumber);
    setIFSC(ifsc);
    setBeneAccountId(beneAccountId);
    setLabelsAcc(labels);

    const isRecreateFlow = mapingData === "renderData";
    const isAccountChanged =
      txnPayLoad?.beneAccountId && txnPayLoad?.beneAccountId !== beneAccountId;

    if (!isRecreateFlow || isAccountChanged) {
      setSelectedCategory(null);
      setCatShow(true);
      setCatSelect(false);
    }

    dispatch(panLookUp({ pan_number: panNo }));
    dispatch(
      bankLookUp({
        ifsc: ifsc,
        bank_account_no: accountNumber,
      }),
    );
    dispatch(getAllCategories());

    let matchedCategory = null;

    // this will never run?
    if (
      type === "PayReimburseTxn" &&
      categoryIds.length > GlobalConfiguration?.lengthCheckZero
    ) {
      setSelectedCategory({
        name: categoriesArray[0],
        configuration: categories?.find((cat) =>
          cat?.category_name
            ?.toLowerCase()
            .includes(categoriesArray[0].toLowerCase()),
        )?.configuration,
      });
    }

    setTxnPayLoad((prev) => ({
      ...prev,
      bankAccountName: accountName,
      beneAccountId: beneAccountId,
      bankAccountIFSC: ifsc,
      bankAccountNo: accountNumber,
      bankLogo: bankLogo,
      pan: panNo,
      labels: labels,
      selectedCategory: matchedCategory ?? null,
      mergeCategory: null,
    }));
    setAmountInWords("");
    handleCloseModal();

    if (beneSuccessData?.beneficiary_accounts?.[0]?.id !== beneAccountId) {
      setAccountSelect(false);
      setCatShow(true);
    }
  };

  useEffect(() => {
    dispatch(getAllCategories());
    if (currentAccountDetails?.type === "payReimbursementdetails") {
      dispatch(panLookUp({ pan_number: txnPayLoad?.pan }));
      dispatch(
        bankLookUp({
          ifsc: txnPayLoad?.bankAccountIFSC,
          bank_account_no: txnPayLoad?.bankAccountNo,
        }),
      );
    }
  }, [currentAccountDetails?.type]);

  useEffect(() => {
    if (mapingData === "renderData" && accountSelect) {
      handleAccountSelection(
        beneSuccessData?.beneficiary_accounts?.[0]?.name,
        beneSuccessData?.beneficiary_accounts?.[0]?.bank_acc_no,
        beneSuccessData?.beneficiary_accounts?.[0]?.ifsc_code,
        beneSuccessData?.beneficiary_accounts?.[0]?.bank_name,
        beneSuccessData?.beneficiary_accounts?.[0]?.category_ids
          ?.map((x) => x.category_name)
          ?.join(","),

        beneSuccessData?.beneficiary_accounts?.[0]?.category_ids?.map(
          (x) => x.category_id,
        ),
        beneSuccessData?.beneficiary_accounts?.[0]?.pan_no,
        beneSuccessData?.beneficiary_accounts?.[0]?.id,
        beneSuccessData?.beneficiary_accounts?.[0]?.labels,
      );
      setCatShow(true);
    }
  }, [mapingData, accountSelect]);

  useEffect(() => {
    const updateBankingHoursStatus = () => {
      const nextStatus = isOutsideBankingHours();
      setIsOutsideBankingHoursActive((prev) =>
        prev === nextStatus ? prev : nextStatus,
      );
    };

    updateBankingHoursStatus();
    const intervalId = setInterval(
      updateBankingHoursStatus,
      IntervalConfiguration.intervalMedium,
    );

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (!isOutsideBankingHoursActive) {
      setShowBanner(false);
    }
  }, [isOutsideBankingHoursActive]);

  const outsideBankingHoursLabel = getOutsideBankingHoursLabel();

  function handleOpenBanner() {
    setShowBanner(true);
  }

  return (
    <>
      {showBanner && (
        <div
          className="fixed top-left-base left-left-base w-screen h-screen z-z-index-max bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={() => setShowBanner(false)}
        >
          <SmallPopupWithBulletPoints
            headerTitle={"Why transaction cannot be processed?"}
            headIconColor="var(--text-primary)"
            closeIconImage={ICONS?.CLOSE}
            closeModal={() => setShowBanner(false)}
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderFontWeight="semibold"
            bulletPoints={[
              `Any transaction created or approved after banking hours i.e. between ${outsideBankingHoursLabel} will be processed on the next bank working day.`,
              "Payments are time-critical (e.g., salary, vendor payment, or bill payment), consider the possible processing delay before proceeding.",
            ]}
          />
        </div>
      )}
      {isOutsideBankingHoursActive && (
        <div className="lg:mx-auto flex Qlg:flex-row flex-col z-z-index-content mb-margin-md mx-margin-md">
          <CommonAlertCard
            title={"Functioning outside banking hours"}
            texts={
              <>
                Transactions will be processed automatically during the next
                bank working day.{" "}
                <span
                  className="underline cursor-pointer font-semibold"
                  onClick={() => handleOpenBanner()}
                >
                  Learn more
                </span>
              </>
            }
          />
        </div>
      )}
      <div className="w-width-full Qlg:px-padding-base px-padding-md pb-padding-md">
        <CommonLayout>
          <div className="w-width-full lg:max-w-[var(--create-box-width)]">
            <SourceDestinationAccountDetail
              type="source"
              modalOpen={openOwner}
              setModalOpen={setOpenOwner}
              txnPayLoad={txnPayLoad}
              setTxnPayLoad={setTxnPayLoad}
              handleOnAccountSelection={handleOwnerSelection}
              TypeRTGS={TypeRTGS}
              currentAccountDetails={currentAccountDetails}
            />
          </div>

          <div className="flex flex-col gap-gap-md">
            <div
              className={`w-width-full lg:max-w-[var(--create-box-width)] ${
                type === "PayReimburseTxn"
                  ? "opacity-light-opacity pointer-events-none"
                  : !txnPayLoad?.ownerBankAccountNo
                    ? "opacity-light-opacity pointer-events-none"
                    : "opacity-base-opacity"
              }`}
            >
              <DestinationReimbursement
                type="destination"
                flow="beneficiary"
                modalOpen={isModalOpen}
                setModalOpen={setIsModalOpen}
                txnPayLoad={txnPayLoad}
                setTxnPayLoad={setTxnPayLoad}
                shouldShowAssociatedAccounts={shouldShowAssociatedAccounts}
                handleOnAccountSelection={handleAccountSelection}
                setActiveType={(e) => {}}
              />
            </div>
          </div>
        </CommonLayout>

        {/* <div className="h-mobile-create-header w-width-full Qmd:hidden block mt-margin-md"></div> */}
      </div>
    </>
  );
};

export default SelectAccount;
